/**
 * Se crea el objeto de contexto, cuando no se puede acceder desde redux
 * @param {string} segment  segmento
 * @returns {object} Devuelve la informacion de contexto construida
 */
export const createSondaContext = (segment) => {
  let clientIDs = null;

  if (window.IC && window.IC.getClientIds) {
    clientIDs = window.IC.getClientIds();
  }

  const context = {
    pageSegment: segment || '',
    contextURL: window.location.href || '',
    clientIDs,
  }

  return context;
}
